export class VisitConfirmationInput {
  leadId: string;
  eventId: string;
  onTrackStatus: string;
  comments: string;
  visitConfirmationStatus: string;
}
